document.addEventListener('DOMContentLoaded', function () {
  var quicknav = document.querySelector('[data-sbt-quicknav]');
  if (!quicknav) return;

  var links = Array.from(quicknav.querySelectorAll('[data-sbt-quicknav-link]'));
  var sections = Array.from(document.querySelectorAll('[data-sbt-fam-section]'));
  if (!links.length || !sections.length) return;

  var linkByTarget = {};
  links.forEach(function (link) {
    linkByTarget[link.getAttribute('data-target')] = link;
  });

  function updateHeaderHeight() {
    var header = document.querySelector('sticky-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('header');
    var h = header ? header.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--sbt-header-height', h + 'px');
  }
  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);

  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var targetId = link.getAttribute('data-target');
      var target = document.getElementById(targetId);
      if (!target) return;
      var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sbt-header-height'), 10) || 0;
      var navH = quicknav.getBoundingClientRect().height;
      var top = target.getBoundingClientRect().top + window.scrollY - headerH - navH - 20;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var id = entry.target.getAttribute('data-target');
        var link = linkByTarget[id];
        if (!link) return;
        if (entry.isIntersecting) {
          links.forEach(function (l) { l.classList.remove('is-active'); });
          link.classList.add('is-active');
        }
      });
    },
    { rootMargin: '-35% 0px -55% 0px', threshold: 0 }
  );

  sections.forEach(function (section) {
    observer.observe(section);
  });
});
document.addEventListener('DOMContentLoaded', function () {
  function setOpen(fam, open) {
    fam.classList.toggle('is-collapsed', !open);
    var btn = fam.querySelector('[data-sbt-fam-toggle]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.querySelectorAll('[data-sbt-fam-toggle]').forEach(function (btn) {
    var fam = btn.closest('.sbt-fam');
    var head = btn.closest('.sbt-fam__head');
    function toggle() { setOpen(fam, fam.classList.contains('is-collapsed')); }
    btn.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
    head.addEventListener('click', toggle);
  });

  // Un clic sur une pastille « Explorer » ouvre la famille repliée avant de défiler
  document.querySelectorAll('[data-sbt-quicknav-link]').forEach(function (link) {
    link.addEventListener('click', function () {
      var fam = document.getElementById(link.getAttribute('data-target'));
      if (fam && fam.classList.contains('is-collapsed')) setOpen(fam, true);
    });
  }, true);
});